import { trackPromise } from "react-promise-tracker";
import Helper from "../../Helper";
import { Activity } from "../../models/Activity";

export function getActivitiesForProject(
    team_subdomain: string,
    project_token: string,
    timezone: string,
    future: boolean = false
): Promise<Activity[]> {
    const urlString =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/activities";

    const url = new URL(urlString);

    if (future) {
        url.searchParams.append("future", future.toString());
    }

    return trackPromise(
        fetch(url.toString(), {
            method: "get",
            credentials: "include",
        })
            .then((data) => {
                if (data.ok) {
                    return data.json();
                }

                throw new Error("Network error.");
            })
            .then((data) => data.map((activity) => Activity.fromApiObject(activity, timezone)))
            .catch(() => [])
    );
}

export async function uploadScheduleForProject(
    team_subdomain: string,
    project_token: string,
    file: FormData
): Promise<string | null> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/activity_imports";

    const fileEntry = file.get("File") as File;

    if (!fileEntry) {
        throw new Error("No file found in FormData");
    }

    // Calculate SHA-256 hash
    const arrayBuffer = await fileEntry.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest("SHA-256", arrayBuffer);

    // Convert to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");

    return trackPromise(
        fetch(url, {
            method: "post",
            body: file,
            credentials: "include",
            headers: {
                "X-File-Checksum": hashHex,
                "X-Checksum-Algorithm": "SHA-256",
            },
        })
            .then((data) => {
                if (data.ok) {
                    return data.json();
                }
                throw new Error("Network error.");
            })
            .then((data) => {
                return data.message;
            })
            .catch(() => {
                return null;
            })
    );
}

export function syncActivitiesForProject(
    team_subdomain: string,
    project_token: string,
    only_update: boolean = false
): Promise<Activity> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        `/projects/${project_token}/activities`;

    return trackPromise(
        fetch(url, {
            method: "put",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                only_update: only_update,
            }),
            credentials: "include",
        }).then((data) => {
            if (data.ok) {
                return data.json();
            }
            throw new Error("Network error.");
        })
    );
}
